var Metrika = /** @class */ (function () {
    function Metrika() {
    }
    Metrika.init = function (id, onload) {
        if (DEVELOPMENT) {
            if (!id) {
                console.warn('Не установлено значение "COUNTER_ID"!');
            }
            return;
        }
        Metrika.id = id;
        (function (d, w, c) {
            // @ts-ignore
            ;
            (w[c] = w[c] || []).push(function () {
                try {
                    // @ts-ignore
                    w['yaCounter' + id] = new Ya.Metrika({ id: id, clickmap: false, trackLinks: false, accurateTrackBounce: false });
                }
                catch (err) {
                    console.error(err);
                }
            });
            var n = d.getElementsByTagName('script')[0], s = d.createElement('script'), f = function () {
                // @ts-ignore
                n.parentNode.insertBefore(s, n);
            };
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://mc.yandex.ru/metrika/watch.js';
            if (onload)
                s.onload = function () { return onload(Metrika.counter()); };
            // @ts-ignore
            if (w.opera === '[object Opera]') {
                d.addEventListener('DOMContentLoaded', f, false);
            }
            else {
                f();
            }
        })(document, window, 'yandex_metrika_callbacks');
    };
    Metrika.params = function (params) {
        if (Metrika.timeoutId)
            clearTimeout(Metrika.timeoutId);
        if (typeof params === 'string') {
            Metrika.paramsData[params] = 1;
        }
        else {
            Metrika.paramsData = Object.assign({}, Metrika.paramsData, params);
        }
        Metrika.timeoutId = setTimeout(function () { return Metrika.sendParams(); }, 100);
    };
    Metrika.goal = function (name) {
        try {
            if (DEVELOPMENT)
                console.log("\u0426\u0435\u043B\u044C: ".concat(name));
            var counter = Metrika.counter();
            if (counter)
                counter.reachGoal(name);
        }
        catch (err) {
            console.error(err);
        }
    };
    Metrika.logError = function (err) {
        var _a;
        console.error(err);
        PRODUCTION && Metrika.params({ error: (_a = {}, _a[String(err.code || err.message).trim()] = 1, _a) });
    };
    Metrika.sendParams = function () {
        var params = Object.assign({}, Metrika.paramsData);
        if (Object.keys(params).length) {
            try {
                removeNullValues(params);
                if (DEVELOPMENT)
                    console.log('Параметры визита:', JSON.stringify(params));
                var counter = Metrika.counter();
                if (counter)
                    counter.params(params);
            }
            catch (err) {
                console.error(err);
            }
            Metrika.paramsData = {};
        }
    };
    Metrika.counter = function () {
        // @ts-ignore
        return window['yaCounter' + Metrika.id];
    };
    Metrika.logTime = function (name, started) {
        var _a, _b;
        var time = ((Date.now() - started) / 1000).toFixed(1);
        Metrika.params({ times: (_a = {}, _a[name] = (_b = {}, _b["".concat(time, "s")] = 1, _b), _a) });
    };
    Metrika.paramsData = {};
    Metrika.timeoutId = 0;
    return Metrika;
}());
export { Metrika };
var removeNullValues = function (params) {
    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            if (params[key] === 0) {
                delete params[key];
            }
            else if (typeof params[key] === 'object') {
                removeNullValues(params[key]);
            }
        }
    }
};
